module.exports = __webpack_public_path__ + "i18n/ru_5cc71fad261a8d06e75ca0b7418d40a4.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ru.json
// module id = 2MCb
// module chunks = 153